import { addMonths, endOfMonth, format, startOfMonth, subMonths } from 'date-fns';
import { useAppDispatch, useAppSelector } from '../../redux/hook.ts';
import { setFilters } from '../../../pages/financialAdvisor/appointments/slice.ts';

export const useMonthCalendar = () => {
    const dispatch = useAppDispatch();
    const filters = useAppSelector(state => state.appointments.filters['month']);

    const changeInterval = (action: 'next' | 'prev' | 'today') => {
        let month = new Date(filters.fromDate!);
        let fromDateTime = format(startOfMonth(month), "yyyy-MM-dd")
        let toDateTime = format(endOfMonth(month), "yyyy-MM-dd")
        if (action === 'next') {
            month = addMonths(month, 1);
            fromDateTime = format(startOfMonth(month), "yyyy-MM-dd")
            toDateTime = format(endOfMonth(month), "yyyy-MM-dd")

        } else if (action === 'prev') {
            month = subMonths(month, 1);
            fromDateTime =format(startOfMonth(month), "yyyy-MM-dd")
            toDateTime = format(endOfMonth(month), "yyyy-MM-dd")
        } else {
            month = new Date();
            fromDateTime = format(startOfMonth(month), "yyyy-MM-dd")
            toDateTime = format(endOfMonth(month), "yyyy-MM-dd")
        }
        dispatch(setFilters({ period: 'month', filters: { fromDate: fromDateTime, toDate: toDateTime } }));
    }

    return {
        filters,
        changeInterval
    };
};

